import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Input, Row } from "antd";
import { useState } from "react";
import { useI18n } from "../../../../../contexts/i18n.js";
import { FormValueDifferFromTemplateTag, diffByJsonStringify } from "../../../valueDifferFromTemplateTag.js";
const FormServiceFieldGeneralProviderContact = ()=>{
    const { __ } = useI18n();
    const [ref, setRef] = useState();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.isProviderCurrentWebsite !== nextValues.isProviderCurrentWebsite,
        children: ({ getFieldValue })=>/*#__PURE__*/ _jsx(Form.Item, {
                label: __("Provider contact"),
                style: {
                    display: getFieldValue("isProviderCurrentWebsite") ? "none" : undefined
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    ref: setRef,
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            gutter: [
                                10,
                                10
                            ],
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 12,
                                    children: /*#__PURE__*/ _jsx(Form.Item, {
                                        name: [
                                            "providerContact",
                                            "phone"
                                        ],
                                        style: {
                                            margin: 0
                                        },
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            addonBefore: __("Phone")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 12,
                                    children: /*#__PURE__*/ _jsx(Form.Item, {
                                        name: [
                                            "providerContact",
                                            "email"
                                        ],
                                        rules: [
                                            {
                                                type: "email",
                                                message: __("Please provide a valid email!")
                                            }
                                        ],
                                        style: {
                                            margin: 0
                                        },
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            addonBefore: __("Email")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 24,
                                    children: /*#__PURE__*/ _jsx(Form.Item, {
                                        name: [
                                            "providerContact",
                                            "link"
                                        ],
                                        rules: [
                                            {
                                                type: "url",
                                                message: __("Please provide a valid URL!")
                                            }
                                        ],
                                        style: {
                                            margin: 0
                                        },
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            addonBefore: __("Contact form")
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                            form: "service",
                            valueName: "providerContact",
                            widthOfRef: ref,
                            style: {
                                marginTop: 3
                            },
                            difference: diffByJsonStringify,
                            ignoreEmptyDefaultValue: true,
                            renderDiff: ({ email, phone, link })=>/*#__PURE__*/ _jsxs(Row, {
                                    gutter: [
                                        10,
                                        10
                                    ],
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            span: 12,
                                            children: /*#__PURE__*/ _jsx(Input, {
                                                addonBefore: __("Phone"),
                                                value: phone,
                                                readOnly: true
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            span: 12,
                                            children: /*#__PURE__*/ _jsx(Input, {
                                                addonBefore: __("Email"),
                                                value: email,
                                                readOnly: true
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            span: 24,
                                            children: /*#__PURE__*/ _jsx(Input, {
                                                addonBefore: __("Contact form"),
                                                value: link,
                                                readOnly: true
                                            })
                                        })
                                    ]
                                })
                        })
                    ]
                })
            })
    });
};
export { FormServiceFieldGeneralProviderContact };
